import { buildCoursesQuery, type fetchCourses } from '@eliadmin/core/src/api/courses/coursers-api';

export const COURSES_PER_PAGE = 9;
export const FREE_COURSE_ID = 58;
export type CourseListSeed = {
  locale: string;
  courseTypeId: number;
  courses: Awaited<ReturnType<typeof fetchCourses>>;
  freeCourse: Awaited<ReturnType<typeof fetchCourses>>;
  updatedAt: number;
};

export function publicCourseListQuery(courseTypeId: number) {
  return {
    ...buildCoursesQuery({ course_type_id: [courseTypeId] }),
    page: 1,
    results: COURSES_PER_PAGE,
    order: 'desc' as const,
    orderBy: 'created_at' as const,
  };
}

export function canUseCourseListSeed(
  seed: CourseListSeed | undefined,
  locale: string,
  courseTypeId: number,
  authToken: string | undefined,
  category: string,
  lecturer: string,
) {
  return !!seed && seed.locale === locale && seed.courseTypeId === courseTypeId &&
    !authToken && category === 'all' && lecturer === 'none';
}
